module.exports = __webpack_public_path__ + "img/mode_bg.0db1da94.png";